import React, {Component} from 'react';
import {Button, Form, Icon, Modal} from 'semantic-ui-react';
import update from 'react-addons-update';
import resources from "../../data/resources";
import {connect} from "react-redux";
import {showModalInvoiceByEmail} from "../../actions/SendInvoiceByEmailActions";
import SaleData from "../../data/SaleData";
import {showToast} from "../../actions/ToastAction";

class SendInvoiceByMail extends Component {

    constructor(props) {
        super(props);
        this.state = {
            data:{
                email: '',
                id: null
            },
            email_error: false,
            sending: false
        }
    }

    handleClose = () => {
        this.props.showModalInvoiceByEmail({
            show:false,
        });
    };

    componentWillReceiveProps(nextProps){
        if(nextProps.modal.id && nextProps.modal.id !== this.state.data.id){
            let data = update(this.state, {
                data: {
                    id: {$set: nextProps.modal.id}
                }
            });
            this.setState(data);
        }
    };

    handleChange = (e, { name, value }) => {
        let data = update(this.state, {
            data: {
                [name]: {$set: value}
            }
        });
        this.setState(data);
        this.setState({email_error:false});
    };

     handleSubmit = () => {
        if(this.state.data.email === '' || !resources.validators.isValidEmailAddress(this.state.data.email)){
            this.setState({email_error:true});
        } else {
            this.setState({sending:true});
            SaleData.sendInvoice(this.state.data, (res) => {
                if (res.send) {
                    this.setState({data:{email: '', id: null}});
                    this.handleClose();
                    this.props.showToast({
                        type:'success',
                        message:'Factura enviada!'
                    });
                } else {
                    this.props.showToast({
                        type:'error',
                        message:'Tenemos un problema al enviar el email!'
                    });
                }
                this.setState({sending:false});
            });
        }
    };

    render() {

        return (
                <Modal open={this.props.modal.show} dimmer='inverted' onClose={this.handleClose} size='tiny'>
                    <Modal.Header>Enviar factura por email</Modal.Header>
                    <Modal.Content>
                        <Modal.Description>
                            <Form onSubmit={this.handleSubmit}>
                                <Form.Group widths='equal'>
                                    <Form.Input
                                        placeholder='Email'
                                        type='email'
                                        name='email'
                                        value={this.state.data.email}
                                        onChange={this.handleChange}
                                        error={this.state.email_error}
                                        fluid
                                    />
                                </Form.Group>
                            </Form>
                        </Modal.Description>
                    </Modal.Content>
                    <Modal.Actions>
                        <Button labelPosition='left' primary disabled={this.state.sending} loading={this.state.sending} icon  onClick={this.handleSubmit}>
                            <Icon name='send' />Enviar
                        </Button>
                        <Button icon='x' labelPosition='left' onClick={this.handleClose} content="Cerrar"/>
                    </Modal.Actions>
                </Modal>
        );
    }
}

function mapDispatchToProps(dispatch){
    return {
        showModalInvoiceByEmail(modal) {
            dispatch(showModalInvoiceByEmail(modal));
        },
        showToast: function (modal) {
            dispatch(showToast(modal))
        },
    }
}

function mapStateToProps(state){
    return{
        modal: state.get('send_invoice_by_email')
    };
}


export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SendInvoiceByMail)



// WEBPACK FOOTER //
// ./src/components/sale/SendInvoiceByMail.js